import { create } from 'zustand';

export const useConfigStore = create((set, get) => ({
  // Extração Básica / Flow
  searchMode: 'fila',
  setSearchMode: (val) => set({ searchMode: val }),

  categories: [],
  setCategories: (val) => set({ categories: typeof val === 'function' ? val(get().categories) : val }),
  
  inputValue: '',
  setInputValue: (val) => set({ inputValue: val }),

  dripMode: false,
  setDripMode: (val) => set({ dripMode: val }),

  totalGoal: 100,
  setTotalGoal: (val) => set({ totalGoal: val }),

  hours: 12,
  setHours: (val) => set({ hours: val }),

  waitMinutes: '',
  setWaitMinutes: (val) => set({ waitMinutes: val }),

  regionState: '',
  setRegionState: (val) => set({ regionState: val }),

  country: 'Brasil',
  setCountry: (val) => set({ country: val }),

  selectedStates: [],
  setSelectedStates: (val) => set({ selectedStates: typeof val === 'function' ? val(get().selectedStates) : val }),
  
  statePicker: '',
  setStatePicker: (val) => set({ statePicker: val }),

  // Extração Avançada
  searchSequence: [],
  setSearchSequence: (val) => set({ searchSequence: typeof val === 'function' ? val(get().searchSequence) : val }),
  
  searchSequenceInput: '',
  setSearchSequenceInput: (val) => set({ searchSequenceInput: val }),

  seqCity: '',
  setSeqCity: (val) => set({ seqCity: val }),

  seqNeighborhood: '',
  setSeqNeighborhood: (val) => set({ seqNeighborhood: val }),

  seqCoords: '',
  setSeqCoords: (val) => set({ seqCoords: val }),

  seqRadius: '',
  setSeqRadius: (val) => set({ seqRadius: val }),

  // Inteligência
  extractSocials: false,
  setExtractSocials: (val) => set({ extractSocials: val }),

  enableAgent3: false,
  setEnableAgent3: (val) => set({ enableAgent3: val }),

  headlessMode: false,
  setHeadlessMode: (val) => set({ headlessMode: val }),
  
  enterpriseType: localStorage.getItem('leadszonemap_enterprise_type') || 'all',
  setEnterpriseType: (val) => {
    localStorage.setItem('leadszonemap_enterprise_type', val);
    set({ enterpriseType: val });
  },

  // Interface do Painel Config
  panelDrip: false,
  setPanelDrip: (val) => set({ panelDrip: val }),
  
  panelRegion: false,
  setPanelRegion: (val) => set({ panelRegion: val }),
  
  panelQueue: false,
  setPanelQueue: (val) => set({ panelQueue: val }),

  // State Hydration from API (usado quando o robô já está rodando)
  hydrateFromPayload: (p) => set((state) => ({
    searchMode: p.search_sequence ? 'avancado' : 'fila',
    categories: p.categories || state.categories,
    totalGoal: p.total_goal || state.totalGoal,
    hours: p.hours || state.hours,
    waitMinutes: p.wait_minutes || state.waitMinutes,
    dripMode: p.drip_mode !== undefined ? p.drip_mode : state.dripMode,
    regionState: p.state || state.regionState,
    selectedStates: p.states || state.selectedStates,
    country: p.country || state.country,
    searchSequence: p.search_sequence || state.searchSequence
  }))
}));
